module.exports = __webpack_public_path__ + "img/resized-APP-0014-1.885abb62.png";